import React from 'react';
import styles from './WorkQueue.module.scss';

function WorkQueueCountCell({ value }) {
  return (
    <span className={value > 0 ? styles.count : `${styles.count} ${styles.muted}`}>
      {value}
    </span>
  );
}

export default WorkQueueCountCell;
